'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();

import { FormFeedback, Label } from 'reactstrap';
import Select from 'react-select';
import customStyles from '../../../utils/react-select';
import { Dictionaries } from '../../../i18n/i18n-config';
import { getI18nUtils } from '../../../i18n/i18n-utils';

interface FormikMultiSelectInputProps {
  name: string;
  formik: any;
  required?: boolean;
  options: { label: string; value: string }[];
  intlKey?: string;
  className?: string;
  disabled?: boolean;
  dictionary: Partial<Dictionaries>;
}

function FormikMultiSelectInput({
  name,
  required,
  intlKey,
  formik,
  options,
  className,
  disabled = false,
  dictionary,
}: FormikMultiSelectInputProps): JSX.Element {
  const { formatMessage } = getI18nUtils(dictionary);

  const { touched, error, value } = formik.getFieldMeta(name);

  return (
    <div className={className || ''}>
      <Label for={name} className={required ? 'required' : ''}>
        {formatMessage({ id: intlKey || name })}
      </Label>

      <Select
        isDisabled={disabled}
        isMulti
        name="license"
        id="license"
        className={touched && error ? `is-invalid` : ''}
        value={options.filter((opt) => value.includes(opt.value))}
        onChange={(selected) => formik.setFieldValue(name, selected?.map((v) => v.value) || [])}
        options={options}
        styles={customStyles}
      />

      {formik.errors[name] && <FormFeedback>{formatMessage({ id: formik.errors[name] })}</FormFeedback>}
    </div>
  );
}

export default FormikMultiSelectInput;
